import { IconDeviceTv, IconMail, IconCategory2, IconSettings2, IconCalendarEvent, IconChartPie, IconBook, IconClockHour2, IconReport } from "@tabler/icons-vue"

export const InternalMenus = {
    '/Internal/Core': {
        label: 'Dashboard',
        icon: IconSettings2,
    },
    '/Internal/Performance': {
        label: 'Business Performance',
        icon: IconChartPie,
    },
    '/Internal/Program': {
        label: 'My Program',
        icon: IconCategory2,
    },
    '/Internal/Webinar': {
        label: 'Webinar',
        icon: IconDeviceTv,
    },
    '/Internal/Course': {
        label: 'Course',
        icon: IconBook,
    },
    '/Internal/Calendar': {
        label: 'Calendar',
        icon: IconCalendarEvent,
    },
    '/Internal/Notification': {
        label: 'Notification',
        icon: IconMail,
    },
};

export const MentorInternalMenus = {
    '/Mentor/Internal/Core': {
        label: 'Dashboard',
        icon: IconSettings2,
    },
    '/Mentor/Internal/Availability': {
        label: 'Availability',
        icon: IconClockHour2,
    },
    '/Mentor/Internal/Schedule': {
        label: 'Schedule',
        icon: IconReport,
    },
    '/Mentor/Internal/Calendar': {
        label: 'Calendar',
        icon: IconCalendarEvent,
    },
    '/Mentor/Internal/Notification': {
        label: 'Notification',
        icon: IconMail,
    },
};

export const seoSlug = {
    // Route : seo page slug
    '/': 'home',
    '/Course/Discovery': 'course',
    '/Client': 'program',
    '/Graduates': 'graduate',
    '/about': 'about',
    '/SignUp': 'signup',
    '/SignIn': 'signin',
}

export const openWebinar = (url: string) => {
    // const url = "/Program/Meeting/1";
    const width = 800;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    window.open(
        url,
        "_blank",
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
    );
}
